module.exports = __webpack_public_path__ + "static/media/ysmobile.2ae5d82a.png";